import styles from '../Styles/Footer.module.css';
import Container from '../UI/Container';
import logo from '../../Assets/Logo.png';

const PhoneIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.89 10.6 19.79 19.79 0 01.82 2a2 2 0 012-2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 7.91a16 16 0 006 6l.97-.97a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const MailIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M22 6l-10 7L2 6"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor"/>
  </svg>
);

const TikTokIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M9 12a4 4 0 104 4V4a5 5 0 005 5"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contacto" className={styles.footer}>
      <Container>
        <div className={styles.content}>

          {/* Logo */}
          <a href="#inicio" className={styles.logo}>
            <img src={logo} alt="FacSystem Col" className={styles.logoImage} />
          </a>

          {/* Contacto + Redes */}
          <div className={styles.contact}>

            <a href="tel:3125575616" className={styles.contactLink}>
              <PhoneIcon />
              312 557 5616
            </a>

            <div className={styles.contactSep} />

            <a href="mailto:facsystemcol@gmail.com" className={styles.contactLink}>
              <MailIcon />
              facsystemcol@gmail.com
            </a>

            <div className={styles.contactSep} />

            {/* Redes — handle compartido + íconos */}
            <div className={styles.social}>
              <span className={styles.socialHandle}>@facsystemcol</span>
              <a
                href="https://instagram.com/facsystemcol"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialIcon}
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://tiktok.com/@facsystemcol"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialIcon}
                aria-label="TikTok"
              >
                <TikTokIcon />
              </a>
            </div>

          </div>

          {/* Copyright + Crédito */}
          <p className={styles.copyright}>
            © {currentYear} FacSystem Col. · Desarrollado por Alexandra Sánchez
          </p>

        </div>
      </Container>
    </footer>
  );
};

export default Footer;